enum CommonTranslationVariant {
  uiDateFormat = 'uiDateFormat',
  loading = 'loading',
  chooseDate = 'chooseDate',
  startdate = 'startdate',
  edit = 'edit',
  allOption = 'allOption',
  startRecordingInstructions = 'startRecordingInstructions',
  startRecording = 'startRecording',
  stopRecordingInstructions = 'stopRecordingInstructions',
  stopRecording = 'stopRecording',
  sendRecordingInstructions = 'sendRecordingInstructions',
  sendRecording = 'sendRecording',
  delete = 'delete'
}

export default CommonTranslationVariant;
